// test2880
(2880 && 0);
